<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};
  export const classNames = ['image-plugin', 'cms-tw']
  export const Components = {
    load: [
      'core/extensions/lazy_img/v1.0.0/LazyImg',
    ],
  }
</script>

<script>
  import { getContext } from 'svelte'
  import { fade, scale } from 'svelte/transition'

  export let fields = {}

  const platform = getContext('platform')
  const isLoggedIn = platform.api.core.isLoggedIn()

  $: imageSrc = fields.imageSrc || ''
  $: newTab = fields.newTab || false

  // responsive src
  $: alt = fields.alt || ''
  $: isExpandable = fields.isExpandable || false
  $: width = fields.width || null
  $: imageLink = fields.imageLink || ''
  $: alignmentClass = fields.alignmentClass || ''
  $: style = `
    ${fields?.aspectRatio?.width && fields?.aspectRatio?.height ? `aspect-ratio: ${fields.aspectRatio.width}/${fields.aspectRatio.height};` : ''}
    ${fields?.objectFit ? `object-fit: ${fields.objectFit};` : ''}
  `

  let isExpanded = false

  function handleClick () {
    if (!isExpandable) {
      return
    }
    isExpanded = true
  }
</script>

{#if (!imageSrc || imageSrc === '') && isLoggedIn}
  <div class="no-image">
    <h3>Image</h3>
    <p>Enter edit mode and select this plugin to add an image</p>
  </div>
{:else}
  <svelte:element
    this={imageLink ? 'a' : 'div'}
    class="image-plugin"
    class:hasLink={imageLink}
    href={imageLink}
    target={newTab ? '_blank' : '_self'}
  >
    <Components.LazyImg
      src={imageSrc}
      width={width}
      className={alignmentClass || ''}
      alt={alt || 'Image'}
      on:expand={handleClick}
      isExpandable={isExpandable && !imageLink}
      style={style}
    />
  </svelte:element>
{/if}

{#if isExpanded}
  <div class="full-screen" in:fade={{ duration: 100 }} out:fade={{ duration: 100, delay: 100 }} on:click={() => { isExpanded = false }}>
    <div class="full-screen-image" in:scale={{ start: 0.95, duration: 100, delay: 100 }} out:scale={{ start: 0.95, duration: 100 }}>
      <Components.LazyImg src={imageSrc} alt={alt || 'Image'} />
    </div>
    <button class="close-gallery" on:click={() => { isExpanded = false }}>
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
        <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/>
      </svg>
    </button>
  </div>
{/if}

<style lang="scss">.no-image {
  width: 100%;
  outline: dashed 2px #888;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  padding: 15px;
  box-sizing: border-box;
  text-emphasis: center;
}

.hasLink {
  cursor: pointer;
}

.image-plugin {
  display: flex;
}

.full-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(5px) brightness(0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  cursor: zoom-out;
}

.full-screen-image {
  width: calc(90% - (20px + 5vw));
  height: calc(90% - 50px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.full-screen-image :global(img) {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.close-gallery {
  width: 45px;
  height: 45px;
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  color: white;
  border: 0 solid transparent;
  cursor: pointer;
}</style>
